import { useCallback, useEffect, useMemo, useState } from "react";
import { useOrganisation } from "@utilities/hooks/services/useOrganisation";
import { Organisation } from "@utilities/types";

export const useControllers = () => {

    const {
        organisation,
        isOrganisationInfosIsComplete,
        isLoadingUpdatedOrganisation,
        updateOrganisation,
    } = useOrganisation();

    const [isEditing, setIsEditing] = useState<boolean>(false);
    const [organisationName, setOrganisationName] = useState<string>(organisation?.organisationName || "");
    const [organidationCountry, setOrganisationCountry] = useState<string>(organisation?.country || "");
    const [organisationCity, setOrganisationCity] = useState<string>(organisation?.city || "");

    const isValid = useMemo(() => (
        organisationName.length > 0 &&
        organidationCountry.length > 0 &&
        organisationCity.length > 0 &&
        organisationName !== organisation?.organisationName &&
        organidationCountry !== organisation?.country &&
        organisationCity !== organisation?.city
    ), [
        organidationCountry, organisation, 
        organisationCity, organisationName,
    ]);

    useEffect(() => {
        if (!isOrganisationInfosIsComplete) {
            setIsEditing(true)
        }
    }, [isOrganisationInfosIsComplete]);

    const toggleEdit = useCallback(() => setIsEditing((prev) => !prev), []);

    const handleUpdateOrganisation = useCallback(async() => {
        if(isValid){
            const updatedOrganisation:Partial<Organisation> = {
                organisationName,
                country: organidationCountry,
                city: organisationCity,
            };

            await updateOrganisation(updatedOrganisation);
            setIsEditing(false);
        }
    }, [
        isValid, organidationCountry, 
        organisationCity, organisationName, 
        updateOrganisation,
    ]);

    const handleLogoChange = useCallback((file: File) => {
        
    }, []);

    return {
        organisation, isEditing, isValid,
        isLoadingUpdatedOrganisation,
        isOrganisationInfosIsComplete,
        organisationName, setOrganisationName,
        organisationCity, setOrganisationCity,
        organidationCountry, setOrganisationCountry,
        toggleEdit, handleLogoChange,
        handleUpdateOrganisation,
    };
};
